import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '~/store/app.store';

const boundaryRenderingSelector = (state: AppState) => state.frontendState.mapTools.boundary.boundaryRendering;
export const useBoundaryRenderingSelector = () => useSelector(boundaryRenderingSelector);
